<template>
    <div class="footer">
        <div class="page-content">
            <div class="container">
                <div class="row align-items-top justify-content-md-center">
                    <div class="col-sm-3 text-left mb-4">
                        <p>1.248.591.0333</p>
                        <p><a href="mailto:info@livio.io">info@livio.io</a></p>
                    </div>
                    <div class="col-sm-3 text-left mb-4">
                        <p>332 E Lincoln Ave.</p>
                        <p>Royal Oak, MI 48067</p>
                    </div>
                    <div class="col-sm-3 text-left mb-4">
                        <p>© 2022 Livio. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
        };
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue